export class ProposalProjectObjectiveOperational{
    constructor(id, title, description, proposalProject){
        this.id = id;
        this.title = title;
        this.description = description;
        this.proposalProject = proposalProject;
    }
    static createFromResponseData(responseData){
        return new ProposalProjectObjectiveOperational(
            responseData.id,
            responseData.title,
            responseData.description,
            responseData.proposalProject
        );
    }
};